import config from 'config';
import { action, computed, observable } from 'mobx';
import axios from '../lib/axios';

class AuthenticationStore {
  @observable inputEmail;
  @observable inputCpf;
  @observable user;
  @observable isSending = false;
  @observable isChecked = false;
  @observable attempts = 0;
  @observable errorMessage;

  constructor() {
    this.setInputDefaults();
    this.triggerCustomEvent = this.triggerCustomEvent.bind(this)
  }

  triggerCustomEvent(){
    if (this.user.region) {
      document.getElementsByTagName('body')[0].setAttribute("data-regional", this.user.region.name)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'userAuthenticated' });
    }
  }

  @action validate() {
    const token = localStorage.getItem(config.api.token);
    if (token) {
      axios.get('/authentications/validate')
      .then((result) => {
        localStorage.setItem(config.api.token, result.data.token);
        this.user = result.data.user;
        this.isChecked = true;
        this.triggerCustomEvent()
      })
      .catch((error) => {
        localStorage.removeItem(config.api.token);
        this.isChecked = true;
      });
    }
    else {
      this.isChecked = true;
    }
  }

  get inputDefaults() {
    return { valid: true, value: null };
  }

  setInputDefaults() {
    this.inputEmail = this.inputDefaults;
    this.inputCpf = this.inputDefaults;
  }

  @action setInputEmail(email) {
    this.inputEmail.value = email;
    if (this.attempts)
      this.validateFormUpdateEmail();
  }

  @action setInputCpf(cpf) {
    this.inputCpf.value = cpf;
    if (this.attempts)
      this.validateFormLogin();
  }

  @action validateFormLogin() {
    this.errorMessage = undefined;
    const inputNoMask = this.inputCpf.value ? this.inputCpf.value.replace(/\D/g, '') : '';
    this.inputCpf.valid = (this.inputCpf.value &&
                           this.inputCpf.value.trim() != "" &&
                           (inputNoMask.length === 11 || inputNoMask.length === 14))

    if (!this.inputCpf.valid)
      this.errorMessage = 'Verifique o preenchimento dos campos.';
    return this.inputCpf.valid;
  }

  @action validateFormUpdateEmail() {
    this.errorMessage = undefined;
    let regexEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    this.inputEmail.valid = (regexEmail.test(this.inputEmail.value) );

    if (!this.inputEmail.valid)
      this.errorMessage = 'Verifique o preenchimento dos campos.';
    return this.inputEmail.valid;
  }

  @action login() {
    this.attempts += 1
    this.errorMessage = '';
    if (this.validateFormLogin()) {
      this.isSending = true;
      axios.post('/authentications', {
        document: this.inputCpf.value.replace(/\D/g, ''),
        origin: 'desktop'
      })
      .then((result) => {
        localStorage.setItem(config.api.token, result.data.token);
        this.isSending = false;
        this.user = result.data.user;
        this.attempts = 0;
        this.setInputDefaults();
        this.triggerCustomEvent()
      })
      .catch((error) => {
        this.errorMessage = 'Dados inválidos, verifique.'
        this.isSending = false;
      });
    }
  }

  @action updateEmail() {
    this.attempts += 1
    this.errorMessage = '';
    if (this.validateFormUpdateEmail()) {
      this.isSending = true;
      axios.put('/users', { email: this.inputEmail.value })
      .then((result) => {
        this.isSending = false;
        this.user.email = this.inputEmail.value;
        this.attempts = 0;
        this.setInputDefaults();
      })
      .catch((error) => {
        this.isSending = false;
        this.errorMessage = 'Ocorreu um erro ao tentar atualizar seus dados.'
      });
    }
  }

  @action logout() {
    localStorage.removeItem(config.api.token);
    this.user = undefined;
  }

  @computed get isAuthenticated() {
    return this.user;
  }

  @computed get userDidUpdateEmail() {
    return this.user.email && this.user.email.length > 0;
  }

  @computed get userCanAccess() {
    return this.isAuthenticated && this.userDidUpdateEmail;
  }

  @computed get userCanAnswerQuestions() {
    return this.user.profile == 'gerente';
  }
}

export default new AuthenticationStore();



// WEBPACK FOOTER //
// ./src/stores/AuthenticationStore.js